import "./Shop.css";

import { Link, useParams, useSearchParams } from "react-router-dom";

import { useEffect, useState } from "react";

import { loadProducts } from "../../data/loadProducts";

const Shop = () => {
  const { category } = useParams();
  const [searchParams] = useSearchParams();
  const filter = searchParams.get("filter");

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* LOAD PRODUCTS */
  useEffect(() => {
    async function fetchProducts() {
      setLoading(true);
      try {
        const data = await loadProducts();
        console.log("data", data);
        setProducts(data);
        setError("");
      } catch (err) {
        setError(err.message || "Unable to load products from the server.");
      } finally {
        setLoading(false);
      }
    }

    fetchProducts();
  }, []);

  /* FILTER PRODUCTS */
  useEffect(() => {
    let data = [...products];

    if (category) {
      const selectedCategory = category
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-");

      data = products.filter((item) => {
        const slug = String(item.category || "")
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-");
        const display = String(item.displayCategory || "")
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-");
        if (selectedCategory === "paithani") {
          return slug.includes("paithani") || display.includes("paithani");
        }

        // Match the Shivreva Navbar route with the backend category
        if (selectedCategory === "shivreva") {
          return slug.includes("shivreva") || display.includes("shivreva");
        }

        if (selectedCategory === "banarasi") {
          return slug.includes("banarasi") || display.includes("banarasi");
        }

        return slug === selectedCategory || display === selectedCategory;
      });
    } else if (filter === "new") {
      data = products.filter((item) => item.isNewArrival);
    } else if (filter === "signature") {
      data = products.filter((item) => item.isSignature);
    } else if (filter === "rare") {
      data = products.filter((item) => item.rare || item.isRare);
    }

    // Show the newest products first within the selected category/filter.
    data.sort((a, b) => {
      const getCreatedTime = (product) => {
        const value =
          product.createdAt ?? product.CreatedAt ?? product.created_at;
        const time = value ? new Date(value).getTime() : 0;
        return Number.isFinite(time) ? time : 0;
      };

      const dateDifference = getCreatedTime(b) - getCreatedTime(a);
      if (dateDifference !== 0) return dateDifference;

      // If creation dates are missing/equal, use the newer (larger) ID as a fallback.
      return (Number(b.id) || 0) - (Number(a.id) || 0);
    });

    setFilteredProducts(data);
  }, [products, category, filter]);

  /* PAGE TITLE */
  const pageTitle = category
    ? `${category.replace(/-/g, " ").toUpperCase()} COLLECTION`
    : filter === "new"
      ? "NEW ARRIVALS"
      : filter === "signature"
        ? "SIGNATURE COLLECTION"
        : filter === "rare"
          ? "RARE & EXCLUSIVE"
          : "ALL COLLECTIONS";

  const breadcrumb = category
    ? category.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : filter === "new"
      ? "New Arrivals"
      : filter === "signature"
        ? "Signature Collection"
        : filter === "rare"
          ? "Rare & Exclusive"
          : "Shop";

  if (loading) {
    return (
      <section className="shop-page">
        <div className="container">
          <div className="loading">Loading Products...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="shop-page">
      <div className="container">
        <div className="shop-header">
          <p>Home / {breadcrumb}</p>
          <h1>{pageTitle}</h1>
        </div>

        {error && (
          <div className="no-product">
            <h2>Unable to load products</h2>
            <p>{error}</p>
          </div>
        )}
        <div className="shop-grid">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => {
              const currentPrice =
                Number(String(product.price ?? 0).replace(/[₹,\s]/g, "")) || 0;

              // const oldPrice = product.oldPrice
              //   ? Number(String(product.oldPrice).replace(/[₹,\s]/g, "")) || 0
              //   : 0;
              // const oldPrice = product.oldPrice
              //   ? Number(String(product.oldPrice).replace(/[₹,\s]/g, "")) ||
              //     Math.round(currentPrice / 0.9)
              //   : Math.round(currentPrice / 0.9);
              const oldPrice =
                product.oldPrice !== null &&
                product.oldPrice !== undefined &&
                String(product.oldPrice).trim() !== ""
                  ? Number(String(product.oldPrice).replace(/[₹,\s]/g, ""))
                  : Math.round(currentPrice / 0.9);
              return (
                <Link
                  key={product.id}
                  to={`/product/${product.id}`}
                  className="shop-card"
                >
                  <div className="shop-image">
                    {product.soldOut && (
                      <span className="shop-sold-out-badge">Sold Out</span>
                    )}

                    {/* <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      decoding="async"
                    /> */}

                    {product.image ? (
                      <img
                        src={product.image}
                        alt={product.name || "Handloom saree"}
                        loading="lazy"
                        onError={(e) => {
                          console.error("Shop image failed:", product.image);
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    ) : (
                      <div className="product-image-placeholder">
                        Image unavailable
                      </div>
                    )}
                  </div>

                  <span>{product.displayCategory || product.category}</span>

                  <h3>{product.name}</h3>

                  <div className="shop-price-row">
                    <span className="shop-new-price">
                      ₹{currentPrice.toLocaleString("en-IN")}
                    </span>

                    <span className="shop-old-price">
                      ₹{oldPrice.toLocaleString("en-IN")}
                    </span>
                  </div>
                </Link>
              );
            })
          ) : (
            <div className="no-product">
              <h2>No products found.</h2>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Shop;
